// Calendar link helpers for "Add to Calendar" buttons
// Event time: June 27, 2027, 6:00 PM - 10:00 PM Central Time (Chicago = America/Chicago, CDT = UTC-5)
// In UTC: 2027-06-27 23:00:00Z to 2027-06-28 03:00:00Z

const EVENT_TITLE = "33 RPM — Fine Dining in Rotation";
const EVENT_DETAILS =
  "A private supper club evening — six-movement Mediterranean menu by a chef from Aba (West Loop), signature cocktails, and a vinyl soundtrack curated by the room. Cocktail elegant attire.";
const EVENT_LOCATION = "235 West Van Buren Street, Downtown Chicago";
const START_UTC = "20260627T230000Z";
const END_UTC = "20260628T030000Z";

export const googleCalendarUrl = () => {
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: EVENT_TITLE,
    dates: `${START_UTC}/${END_UTC}`,
    details: EVENT_DETAILS,
    location: EVENT_LOCATION,
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

export const icsDataUri = () => {
  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//33RPM//Invitation//EN",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    "BEGIN:VEVENT",
    `UID:33rpm-${Date.now()}@33rpmdining.com`,
    `DTSTAMP:${new Date().toISOString().replace(/[-:]/g, "").replace(/\.\d+/, "")}`,
    `DTSTART:${START_UTC}`,
    `DTEND:${END_UTC}`,
    `SUMMARY:${EVENT_TITLE}`,
    `DESCRIPTION:${EVENT_DETAILS.replace(/,/g, "\\,")}`,
    `LOCATION:${EVENT_LOCATION.replace(/,/g, "\\,")}`,
    "STATUS:CONFIRMED",
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");
  return `data:text/calendar;charset=utf-8,${encodeURIComponent(ics)}`;
};
